import { createClient } from "@supabase/supabase-js";

// Supabase configuration
// These vars are prefixed with VITE_ so they are exposed to the browser
const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL || "http://127.0.0.1:54321";

const supabasePublishableKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY || // fallback for older setups
  "";

// Fail fast in production if misconfigured
if (!supabasePublishableKey && import.meta.env.MODE === "production") {
  throw new Error("Missing VITE_SUPABASE_PUBLISHABLE_KEY environment variable");
}

// Helpful warnings for local dev
if (!supabasePublishableKey && import.meta.env.MODE === "development") {
  console.warn("⚠️  Supabase publishable key not set.");
  console.warn("   Using empty key — auth & database calls will fail.");
  console.warn("   Run `npx supabase status` to get your local keys,");
  console.warn(
    "   then add VITE_SUPABASE_PUBLISHABLE_KEY to apps/frontend/.env.local",
  );
}

// Create the Supabase browser client
export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// Dev-only connection info
if (import.meta.env.MODE === "development") {
  console.log("🔌 Supabase client initialized (browser)");
  console.log("   URL:", supabaseUrl);
  console.log(
    "   Key:",
    supabasePublishableKey
      ? "***" + supabasePublishableKey.slice(-4)
      : "(missing)",
  );
}
